import { productService } from '../../helpers/services/product.service';
import i18n from '@/i18n'
import { sharedHelper, filtersHelper } from '@/utils'
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const PRODUCT_MODULE = 'product';

// define action 
export const GET_ALL_PRODUCTS = 'getAllProducts';
export const GET_PRODUCT = 'getProduct';
export const UPDATE_PRODUCT = 'updateProduct';
export const CREATE_PRODUCT = 'createProduct';
export const UPDATE_PRODUCT_STATUS = 'updateProductStatus';
export const EXPORT_PRODUCT_LIST = 'exportProductList';
export const EXPORT_PRODUCT = 'exportProduct';
export const UPDATE_PRODUCT_HALEX = 'updateProductHalex';
export const CREATE_PRODUCT_HALEX = 'createProductHalex';
export const UPDATE_PRODUCT_HALEX_STATUS = 'updateProductHalexStatus';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_PRODUCTS_REQUEST = "getAllProducts";
const GET_PRODUCT_REQUEST = "getProduct";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    async [GET_ALL_PRODUCTS]({ commit }, { filter }) {
        await productService
            .getAllProducts(filter)
            .then(
                (result) => {
                    commit(GET_ALL_PRODUCTS_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [GET_PRODUCT]({ commit }, { id }) {
        productService
            .getProduct(id)
            .then(
                (result) => {
                    commit(GET_PRODUCT_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_PRODUCT]({ commit }, { data }) {
        commit(REQUEST)
        productService
            .updateProduct(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.product')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS, 1)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_PRODUCT]({ commit }, { data }) {
        commit(REQUEST)
        productService
            .createProduct(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t("message.createXSuccess", [i18n.t('module.product')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS, 1)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_PRODUCT_STATUS]({ dispatch }, { filter, data }) {
        productService
            .updateProductStatus(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_PRODUCTS, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    [UPDATE_PRODUCT_HALEX]({ commit }, { data }) {
        commit(REQUEST)
        productService
            .updateProductHalex(data)
            .then(
                // eslint-disable-next-line no-unused-vars
                (result) => {
                    var message = i18n.t("message.updateXSuccess", [i18n.t('module.product')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS, 2)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [CREATE_PRODUCT_HALEX]({ commit }, { data }) {
        commit(REQUEST)
        productService
            .createProductHalex(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t("message.createXSuccess", [i18n.t('module.product')]);
                    sharedHelper.alertSuccessMessage(message)
                    commit(SUCCESS, 2)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                    commit(FAILURE)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [UPDATE_PRODUCT_HALEX_STATUS]({ dispatch }, { filter, data }) {
        productService
            .updateProductStatusHalex(data)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (result) => {
                    var message = i18n.t('message.updateStatusSuccess');
                    sharedHelper.alertSuccessMessage(message)
                    dispatch(GET_ALL_PRODUCTS, { filter })
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars  
    [EXPORT_PRODUCT_LIST]({ commit }, { filter }) {
        productService
            .exportProductLists(filter)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (response) => {
                    const blob = new Blob([response], {
                        type: 'text/csv;charset=utf-8;'
                    });

                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'rnd_products.csv');
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [EXPORT_PRODUCT]({ commit }, { id }) {
        productService
            .exportProduct(id)
            .then(
                // eslint-disable-next-line no-unused-vars  
                (response) => {
                    const blob = new Blob([response], {
                        type: 'text/csv;charset=utf-8;'
                    });

                    const url = window.URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'rnd_product.csv');
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                    window.URL.revokeObjectURL(url);
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },
};

export const mutations = {

    [SUCCESS](state, from) {
        state.status = {};
        if (from == 1) {
            router.push({ name: "Product-listing" });
        }
        else if (from == 2) {
            router.push({ name: "Product-halex-listing" });
        }
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true, create: true };
    },
    [GET_ALL_PRODUCTS_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                name: o.name,
                lrmp: o.lrmp,
                referenceNumber: o.reference_number,
                dor: filtersHelper.getDateFormat(o.dor),
                expiredDate: filtersHelper.getDateFormat(o.expired_date),
                remark: o.remark,
                dossierSubmissionDate: filtersHelper.getDateFormat(o.dossier_submission_date),
                approvalDate: filtersHelper.getDateFormat(o.approval_date),
                isRegisterCert: o.is_registration_certificated,
                isActive: o.is_active,
                shelfLifeProduction: o.shelf_life_production,
                shelfLifeTime: o.shell_life_time,
                endorseLabel: data.endorse_label,
                endorseLabelArray: (o.endorse_label || '').split(',').map(s => s.trim()).filter(Boolean),
                brand: o.brand,
                form: o.form,
                class: o.class,
                rndProductMoa: o.rnd_product_moas,
                status: o.status,
                type: o.type,
                purpose: o.purpose,
                productAI: o.rnd_product_ai,
                productSource: o.rnd_product_source,
                productQuery: o.rnd_product_query,
                product: o.rnd_product,
                productPrinterProof: o.rnd_product_printer_proof,
                productPayment: o.rnd_product_payment,
                productLabel: o.rnd_product_label,
                productRegisterCert: o.rnd_product_register_certification,
                productSNS: o.rnd_product_sns,
                productRecommendation: o.rnd_product_recommendation,
                rndProductNewLabels: (o.rnd_product_new_labels ?? []).map(item => ({
                    uuid: item.uuid,
                    date: filtersHelper.getDateFormat(item.date),
                    isActive: item.is_active,
                    createdBy: item.created_by,
                    createdAt: filtersHelper.getDateFormat(item.created_at),
                    updatedBy: item.updated_by,
                    updatedAt: filtersHelper.getDateFormat(item.updated_at),
                    labels: (item.labels ?? []).map(i => ({
                        uuid: i.uuid,
                        size: i.size,
                        remark: i.remark,
                        packagingMaterial: i.packaging_material,
                        isActive: i.is_active,
                        created_by: i.created_by,
                        created_at: filtersHelper.getDateFormat(i.created_at),
                        updated_by: i.updated_by,
                        updated_at: filtersHelper.getDateFormat(i.updated_at),
                        images: (i.images ?? []).map(img => ({
                            uuid: img.uuid,
                            imageUrl: img.image_url,
                        })),
                    })),
                })),
                createdBy: o.created_by,
                createdAt: filtersHelper.getDateFormat(o.created_at),
                updatedBy: o.updated_by,
                updatedAt: filtersHelper.getDateFormat(o.updated_at)
            }
        })
    },
    [GET_PRODUCT_REQUEST](state, data) {
        let o = data.data
        state.details = {
            uuid: o.uuid,
            brandName: o.name,
            lrmp: o.lrmp,
            referenceNumber: o.reference_number,
            formatDOR: filtersHelper.getDateFormat(o.dor),
            formatExpiredDate: filtersHelper.getDateFormat(o.expired_date),
            dor: o.dor,
            expiredDate: o.expired_date,
            remark: o.remark,
            formatDossierSubmissionDate: filtersHelper.getDateFormat(o.dossier_submission_date),
            formatApprovalDate: filtersHelper.getDateFormat(o.approval_date),
            dossierSubmissionDate: o.dossier_submission_date,
            approvalDate: o.approval_date,
            isRegisterCert: o.is_registration_certificated,
            isActive: o.is_active,
            shelfLifeProduction: o.shelf_life_production,
            endorseLabel: o.endorse_label,
            endorseLabelArray: (o.endorse_label || '')
                .split(',')
                .map(s => s.trim())
                .filter(Boolean),
            brand: o.brand,
            form: o.form,
            class: o.class,
            rndProductMoa: o.rnd_product_moas,
            status: o.status,
            type: o.type,
            purpose: o.purpose,
            productAI: o.rnd_product_ai,
            productSource: o.rnd_product_source,
            productQuery: o.rnd_product_query,
            product: o.rnd_product,
            productPrinterProof: o.rnd_product_printer_proof,
            productPayment: o.rnd_product_payment,
            productLabel: o.rnd_product_label,
            productRegisterCert: o.rnd_product_register_certification,
            productSNS: o.rnd_product_sns,
            productRecommendation: o.rnd_product_recommendation,
            createdBy: o.created_by,
            createdAt: filtersHelper.getDateFormat(o.created_at),
            updatedBy: o.updated_by,
            updatedAt: filtersHelper.getDateFormat(o.updated_at),
            shelfLifeTime: o.shell_life_time != null ? {
                code: o.shell_life_time,
                name: o.shell_life_time
            } : '',
            companyID: o.brand != null ? {
                value: o.brand.uuid,
                text: o.brand.name
            } : '',
            formulationID: o.form != null ? {
                value: o.form.uuid,
                text: o.form.name
            } : '',
            classID: o.class != null ? {
                value: o.class.uuid,
                text: o.class.name
            } : '',
            // moaID: o.moa != null ? {
            //     value: o.moa.uuid,
            //     text: o.moa.name
            // } : '',
            typeID: o.type != null ? {
                value: o.type.uuid,
                text: o.type.name
            } : '',
            purposeID: o.purpose != null ? {
                value: o.purpose.uuid,
                text: o.purpose.name
            } : '',
            statusID: o.status != null ? {
                value: o.status.uuid,
                text: o.status.name
            } : '',
            rndProductNewLabels: (o.rnd_product_new_labels ?? []).map(item => ({
                uuid: item.uuid,
                date: filtersHelper.getDateFormat(item.date),
                isActive: item.is_active,
                createdBy: item.created_by,
                createdAt: filtersHelper.getDateFormat(item.created_at),
                updatedBy: item.updated_by,
                updatedAt: filtersHelper.getDateFormat(item.updated_at),
                labels: (item.labels ?? []).map(i => ({
                    uuid: i.uuid,
                    size: i.size,
                    remark: i.remark,
                    packagingMaterial: i.packaging_material,
                    isActive: i.is_active,
                    created_by: i.created_by,
                    created_at: filtersHelper.getDateFormat(i.created_at),
                    updated_by: i.updated_by,
                    updated_at: filtersHelper.getDateFormat(i.updated_at),
                    images: (i.images ?? []).map(img => ({
                        uuid: img.uuid,
                        imageUrl: img.image_url,
                    })),
                })),
            }))
        }

    }
}


